import { render, staticRenderFns } from "./BibliotecaVirtualPage.vue?vue&type=template&id=6b4feb8d"
import script from "./BibliotecaVirtualPage.js?vue&type=script&lang=js&external"
export * from "./BibliotecaVirtualPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports